import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnClick } from "../../../library-js/dom-tools/EventListeners";
import { Link } from "../../../library-js/dom-tools/LinkResolver";
import { ContextMenu } from "../../../library-templates/context--menu/ContextMenu";
import { Rokojori } from "../Rokojori";
import { LinkContextEntry } from "./LinkContextMenuEntry";

export class HeaderMenu
{
  static create( name:string, entries:LinkContextEntry[] )
  {
    let contextMenu = new ContextMenu( name );


    entries.forEach( 
      e => 
      {

        let anchor = ElementType.anchor.create( e.label );
        anchor.innerHTML = anchor.innerHTML.replace( "___", "&nbsp;&nbsp;&nbsp;");
        let link   = Link.Root( e.link );

        let convertedLink = Rokojori.$.pageHandler.createRelativeLink( link );

        convertedLink = convertedLink.prettify();
        
        ElementAttribute.href.to( anchor, convertedLink.path ); 

        OnClick.add( anchor, ()=> { contextMenu.close(); } )
        Rokojori.$.pageHandler.makePageHandleLink( anchor );
 
        console.log( "relative", e.link, convertedLink.path );
             
        
        
        contextMenu.addEntry( anchor );
      }
    );
    
    return contextMenu;
  }
}